import React from 'react';
import './About.css';
import data from '../data.json';

const About = () => {
    return (
        <div className="about-container">
            <div className="about-section">
                <h2 className="about-title">Currently engineering student at the National School of Cognitive Science Engineering (ENSC) in Bordeaux, France</h2>
            </div>
            <div className="about-section">
                <div className="about-left">
                    <div className='about-image-container'>
                        <img src={data.photonb} alt="myphoto" className="about-image" />
                    </div>
                </div>
                <div className="about-right">
                    <p className="about-description">
                        {data.about1}<br/><br/>
                        {data.about2}<br/><br/>
                        {data.about3}<br/><br/>
                        {data.about4}<br/><br/>
                        Feel free to conatact me via <a href={`mailto:${data.email}`} className="about-link"><strong>email</strong></a> or <a href={data.linkedin} target="_blank" rel="noopener noreferrer" className="about-link"><strong>LinkedIn</strong></a>.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;